// Keep in step with STUDENT_STEP_CLASS_NAMES in the server delivery policy.
// Archived legacy-only classes remain readable in old rows but cannot be added.
export const studentAuthorableStepTypes = [
    'image', 'introduce_word', 'conversation_listen',
    'quiz_question', 'quiz_question_audio', 'quiz_word', 'match_game',
    'summary', 'select_next_dialog',
    'speak_with_grade', 'type_speak',
    'conversation_listen_without_character', 'conversation_listen_speak',
    'conversation_read_speak', 'conversation_read_with_blank_speak', 'conversation_speak_only',
    'listen_speak', 'listen_speak_no_grade', 'speak_no_grade', 'type_speak_v2',
    'image_select_speak', 'quiz_question_speak',
    'write_open', 'speak_open', 'type_speak_open',
] as const;

export const studentAuthorableStepTypeSet: ReadonlySet<string> = new Set(studentAuthorableStepTypes);
